import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { FormulasComexServiceV2 } from '@sv2/formulasComex/formulas-comex-v2.service';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ColunasFormulasComex } from 'models/formulas-comex/formulasComexViewModel';
import { debounceTime, firstValueFrom, tap } from 'rxjs';
import { KeyValue } from '@angular/common';
import { DeclaracoesImportacaoService } from '../../../services/declaracoes-importacao.service';

@Component({
  selector: 'app-modal-formulas',
  templateUrl: './modal-formulas.component.html',
  styleUrls: ['./modal-formulas.component.css']
})
export class ModalFormulasComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal;
  formulas: ColunasFormulasComex[];
  firstLoad = true;
  hasChanges = false;
  declaracaoID: number;
  duimpID: number;
  tituloModal = '';
  campoCalculado: string;
  valorCampoCalculado = 0;
  formLabels: { [key: string]: string } = {};
  allowClickOutside = true;
  valoresCampos = null;
  notaEntradaImportacaoID = null;

  constructor(
    private formulasService: FormulasComexServiceV2,
    private diService: DeclaracoesImportacaoService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.cadastroForm = new FormGroup({});
    this.declaracaoID = this.prop.declaracaoID;
    this.duimpID = this.prop.duimpID;
    this.tituloModal = this.prop.tituloModal;
    this.campoCalculado = this.prop.campoCalculado;
    this.valorCampoCalculado = this.prop.valorCampoCalculado;
    this.notaEntradaImportacaoID = this.prop.notaEntradaImportacaoID;
    this.carregarFormulas();

    this.subscribeFormValueChanges();
  }

  getLabelCampo(campoOperacao: string): string {
    return this.formulas.find(f => f.campoOperacao === campoOperacao)!.labelCampo;
  }

  show() {
    this.modal.show();
  }

  fechar() {
    if (this.loading['salvando']) return;
    this.closed.emit(this.hasChanges);
  }

  async carregarFormulas() {
    try {
      this.loading['request'] = true;
      this.allowClickOutside = false;
      this.formulas = await this.formulasService.getFormulasComex(this.campoCalculado) as ColunasFormulasComex[];

      for (const formula of this.formulas) {
        this.cadastroForm.addControl(formula.campoOperacao, new FormControl(!formula.inativo));
      }

      await this.recalcular();
    } catch (error) {
      console.error('Erro ao carregar formulas:', error);
    } finally {
      this.loading['request'] = false;
      this.allowClickOutside = true;
    }
  }

  async salvar() {
    try {
      this.loading['salvando'] = true;
      this.allowClickOutside = false;
      this.hasChanges = true;
      const colunas = this.cadastroForm.value;
      for (const formula of this.formulas) {
        formula.inativo = !colunas[formula.campoOperacao];
      }

      const viewModel = { ListaCampos: this.formulas };
      const res = await this.formulasService.salvarFormulasComex(viewModel);
      await this.recalcular();
      if (res) {
        this.formulas = res;
      }
    } catch (error) {
      console.error('Erro ao salvar formulas:', error);
    } finally {
      this.loading['salvando'] = false;
      this.allowClickOutside = true;
    }
  }

  subscribeFormValueChanges() {
    this.cadastroForm.valueChanges.pipe(
      tap(() => {
        if (this.firstLoad) return;

        this.hasChanges = true;
        this.allowClickOutside = false;
      }),
      debounceTime(500)
    ).subscribe(() => {
      if (this.firstLoad) {
        this.firstLoad = false;
        this.allowClickOutside = true;
        return;
      }

      this.salvar();
    });
  }

  async recalcular() {
    try {
      const res = await firstValueFrom(this.diService.recalcularFormulasCampoCalculado(this.declaracaoID, this.duimpID, this.campoCalculado, this.notaEntradaImportacaoID));
      this.valoresCampos = Object.keys(res).map(x => ({ campo: x.toLowerCase(), valor: res[x] }));
      this.valorCampoCalculado = this.valoresCampos.find(x => x.campo === this.campoCalculado.toLowerCase())?.valor || 0;

      this.definirLabels();
    } catch (error) {
      console.error('Erro ao recalcular:', error);
    }
  }

  definirLabels() {
    for (const formula of this.formulas) {
      const valorCampo = this.valoresCampos.find(x => x.campo === formula.campoOperacao.toLowerCase())?.valor;
      this.formLabels[formula.campoOperacao] = formula.labelCampo
        + (![null, undefined].includes(valorCampo) ? ` (R$ ${valorCampo.toFixed(2).replace('.', ',')})` : '');
    }
  }

  originalOrder(a: KeyValue<string, AbstractControl<any, any>>, b: KeyValue<string, AbstractControl<any, any>>): number {
    return 0;
  }
}
